import { BolFieldValue } from "../../../../app/data/pickup-requests/bolModels";
import { fieldHasDisplayValue } from "../../../../app/data/pickup-requests/bolModels";

/** User-entered or corrected values should not show the AI badge */
export const mergeHumanFieldValue = (
  existing: BolFieldValue | undefined,
  value: string
): BolFieldValue => ({
  value,
  confidence: 1,
  aiMessage: null,
  humanProvided: true,
});

export const fieldWasAiExtracted = (field?: BolFieldValue | null): boolean => {
  if (!field || field.humanProvided) return false;
  return fieldHasDisplayValue(field);
};

export const shouldShowAiBadge = (
  field?: BolFieldValue | null,
  showAiBadge = true
): boolean => showAiBadge && fieldWasAiExtracted(field);

export const shouldShowMissingBadge = (
  field?: BolFieldValue | null,
  readOnly?: boolean
): boolean => !readOnly && !fieldHasDisplayValue(field);
